import React from "react";
// @ts-ignore
import { LocalizationContext } from 'react-localize';
import MvModal from "Generic/MvModal";
import ImageGallery, { ReactImageGalleryItem } from 'react-image-gallery';
import "./MvResortModal.sass"
import ReservationService from "Services/reservation.service";
import MvLoader from "Generic/MvLoader/MvLoader";
import ReactHtmlParser from 'react-html-parser';
import MvIcon from "Generic/MvIcon";
import MvLink from "Generic/MvLink";
import MvSelect from "Generic/MvSelect";
import { MvConfirmationModal } from "Generic/MvConfirmationModal/MvConfirmationModal";
import ResortResult from "Interfaces/ResortResultInterface";
import log from "cfg";

interface Props {
  toggle(): void;
  show: boolean;
  propertyCode: string;
  visitResortNewTab?: boolean;
};

interface State {
  resort: any;
  apiLoading: boolean;
  selectedTabIdx: number;
  windowWidth: number;
  selectedGalleryBtn: string;
  galleryIdx: number;
  initialScrolltop: any;  
  showConfirmNavigateAway: boolean;
  heldResorts: ResortResult[]
};

const InitState: State = {
  resort: null,
  apiLoading: true,
  selectedTabIdx: 0,
  windowWidth: 0,
  selectedGalleryBtn: '',
  galleryIdx: 0,
  initialScrolltop: null,
  showConfirmNavigateAway: false,
  heldResorts: [],
};

class MvResortModal extends React.Component<Props, State> {
  reservationService: ReservationService;

  constructor(props: Props) {
    super(props);

    this.state = Object.assign({}, InitState);
    this.reservationService = new ReservationService();
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateWindowDimensions);
    this.updateWindowDimensions();
  }

  componentWillUnmount(): void {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  /**
  * Get the Temporarily Held Reservation(s)
  */
    getHeldResorts() {
      this.reservationService.getHeldResorts()
      .then((heldResorts: ResortResult[]) => {
          this.setState({
              heldResorts,
          });
      }).catch((error: any) =>{
        log.error(`Error: ${JSON.stringify(error)}`);
      });
    }

  updateWindowDimensions = () => {
    this.setState({ windowWidth: window.innerWidth });
  }

  componentWillReceiveProps(nProps: Props) {
    if (this.props.propertyCode !== nProps.propertyCode) {
      this.setState({ apiLoading: true, selectedTabIdx: 0 }, () => {
        this.getResortOverview(nProps.propertyCode);
        this.getHeldResorts();
      });
    }

    if (!this.props.show && nProps.show) {
      const html = document.querySelector('html');
      if (html) {
        html.style.overflow = 'hidden';
      }
    }

    if (this.props.show && !nProps.show) {
      const html = document.querySelector('html');
      if (html) {
        html.style.overflow = 'visible';
      }
    }
  }

  getResortOverview = (propertyCode: string) => {
    this.reservationService.getResortOverview(propertyCode).then(resort => {
      let selectedGalleryBtn = '';
      if (resort.exteriorImageGallery && resort.exteriorImageGallery.length > 0) {
        selectedGalleryBtn = 'exterior';
      } else if (resort.interiorImageGallery && resort.interiorImageGallery.length > 0) {
        selectedGalleryBtn = 'interior';
      } else if (resort.floorPlans && resort.floorPlans.length > 0) {
        selectedGalleryBtn = 'floorplans';
      }

      this.setState({ resort, apiLoading: false, selectedGalleryBtn });
    });
  };

  renderLeftGalleryArrow = (onClick: any, disabled: any) => {
    return (
      <>
        <button
          className='gallery-nav-arrow left'
          disabled={false}
          onClick={() => {
            onClick();
          }}
        >
          <MvIcon
            color="#5F5F5F"
            height="30px"
            width="30px"
            icon="chevronLeft"
          />
        </button>
        <button
          className='thumbnail-nav-arrow left'
          disabled={disabled}
          onClick={() => {
            onClick();
          }}
        >
          <MvIcon
            color="#5F5F5F"
            height="30px"
            width="30px"
            icon="chevronLeft"
          />
        </button>
      </>
    );
  }

  renderRightGalleryArrow = (onClick: any, disabled: any) => {
    return (
      <>
        <button
          className='gallery-nav-arrow right'
          disabled={false}
          onClick={() => {
            onClick();
          }}
        >
          <MvIcon
            color="#5F5F5F"
            height="30px"
            width="30px"
            icon="chevronRight"
          />
        </button>
        <button
          className='thumbnail-nav-arrow right'
          disabled={disabled}
          onClick={() => {
            onClick();
          }}
        >
          <MvIcon
            color="#5F5F5F"
            height="30px"
            width="30px"
            icon="chevronRight"
          />
        </button>
      </>
    );
  }

  getPhotoDescription = (resort: any) => {
    const { selectedGalleryBtn, galleryIdx } = this.state;

    if (!resort) return null;

    if (selectedGalleryBtn === 'interior') {
      return resort.interiorImageGallery[0].images[galleryIdx].altText;
    } else if (selectedGalleryBtn === 'exterior') {
      return resort.exteriorImageGallery[0].images[galleryIdx].altText;
    } else if (selectedGalleryBtn === 'floorplans') {
      return resort.floorPlans[galleryIdx].roomType.name;
    } 
  };

  visitResortWebsite = () => {
    window.open(this.state.resort.resortUrl, '_blank')

    // const hasHolds = this.state.heldResorts.length > 0;
    // if (!hasHolds) {
    //   window.open(this.state.resort.resortUrl, this.props.visitResortNewTab ? '_blank' : '_self')
    // } else {
    //   this.toggleConfirmNavigateAwayModal();
    // }
  };

  /**
   * fired when the 'Cancel' button is clicked
   */
  toggleConfirmNavigateAwayModal = () => {
    this.setState({showConfirmNavigateAway: !this.state.showConfirmNavigateAway});
  }

  render() {
    const { localize } = this.context;
    const {toggle, show} = this.props;

    const { resort, apiLoading } = this.state;

    let content = null;

    let containerStyles = {};

    if (resort) {
      let images: { original: string; thumbnail: string; }[] = [];
      if (this.state.selectedGalleryBtn === 'interior') {
        //CE2RT1C-946: filtering out images that are empty
        images = resort.interiorImageGallery[0].images.filter((image: any) => {
          return image.path !== '';
        }).map((image: any) => ({
          original: image.photo.path,
          thumbnail: image.photo.path,
          originalAlt: image.photo.altText,
          thumbnailAlt: image.photo.altText,
        }));
      } else if (this.state.selectedGalleryBtn === 'exterior') {
        //CE2RT1C-946: filtering out images that are empty
        images = resort.exteriorImageGallery[0].images.filter((image: any) => {
          return image.path !== '';
        }).map((image: any) => ({
          original: image.photo.path,
          thumbnail: image.photo.path,
          originalAlt: image.photo.altText,
          thumbnailAlt: image.photo.altText,
        }));
      } else if (this.state.selectedGalleryBtn === 'floorplans') {
        
        //CE2RT1C-946: filtering out images that are empty
        images = resort.floorPlans.filter((image: any) => {
          return image.floorplanimage !== '';
        }).map((image: any) => ({
          original: image.floorplanimage,
          thumbnail: image.floorplanimage
        }));
      }

      const mobileTabItems = resort.tabs.map((tab: any, i: number) => ({ 
        value: i,
        label: tab.tabName,
        description: tab.tabName
      }));
      
      content = (
        <div className='modal-container'>
          <div className='top-section'>
            <div className='left'>
              <div className='resort-modal-name'>{resort.name}</div>
              <div className='resort-info'>
                <div className='resort-address'>
                  {resort.address ? `${resort.address}, ` : ''}
                  {resort.city ? `${resort.city}, ` : ''}
                  {resort.state ? `${resort.state}, ` : ''}
                  {resort.country ? `${resort.country}` : ''}
                </div>
                <div className='resort-phone'><label>{localize('static.content.resort-modal-phone')}:&nbsp;</label>{resort.phone}</div>
                <div className='resort-checkin'><label>{localize('static.content.resort-modal-checkin-time')}:&nbsp;</label>{resort.checkin} ({localize('static.content.resort-modal-resort-time')})</div>
                <div className='resort-checkin'><label>{localize('static.content.resort-modal-checkout-time')}:&nbsp;</label>{resort.checkout} ({localize('static.content.resort-modal-resort-time')})</div>
              </div>
              </div>
            <div className='right'>
              {/* 
                Commented this line of code for visit resort website link for Go Live. It will be activated once Jahia content is fixed
                <MvLink
                  label={localize("static.content.visit-resort-website")}
                  onClick={this.visitResortWebsite}
              /> */}
              <div className='gallery-btns'>
                {(resort.exteriorImageGallery && resort.exteriorImageGallery.length > 0) &&
                  <button onClick={() => this.setState({ selectedGalleryBtn: 'exterior', galleryIdx: 0 })} className={`${this.state.selectedGalleryBtn === 'exterior' ? 'active': ''}`}>
                    {localize("static.content.gallery-exterior")}
                  </button>
                }
                {(resort.interiorImageGallery && resort.interiorImageGallery.length > 0) && 
                  <button onClick={() => this.setState({ selectedGalleryBtn: 'interior', galleryIdx: 0 })} className={`${this.state.selectedGalleryBtn === 'interior' ? 'active': ''}`}>
                    {localize("static.content.gallery-interior")}
                  </button>
                }
                {(resort.floorPlans && resort.floorPlans.length > 0) &&
                  <button onClick={() => this.setState({ selectedGalleryBtn: 'floorplans', galleryIdx: 0 })} className={`${this.state.selectedGalleryBtn === 'floorplans' ? 'active': ''}`}>
                    {localize("static.content.gallery-floorplans")}
                  </button>
                }
              </div>
            </div>
          </div>
          {(images.length > 0 && images.some((image: any) => image.original)) &&
            <div className='gallery'>
              <ImageGallery
                items={images}
                showPlayButton={false}
                renderLeftNav={this.renderLeftGalleryArrow}
                renderRightNav={this.renderRightGalleryArrow}
                infinite={false}
                onSlide={(index) => {
                  this.setState({ galleryIdx: index })
                }}
                renderItem={(item: ReactImageGalleryItem) => {
                  return (
                    <div className="mv-resort-modal-image" style={{
                      background: `url('${item.original}')`,
                      backgroundRepeat: 'no-repeat',
                      backgroundSize: this.state.selectedGalleryBtn === 'floorplans' ? 'contain' : 'cover',
                      backgroundPosition: '50% 50%',
                      width: '100%',
                    }}>
                    </div>
                  );
                }}
              />
              <p className='photo-description'>{this.getPhotoDescription(resort)}</p>
            </div>
          }
          {this.state.windowWidth <= 900 &&
            <MvSelect
              name="mv-resort-modal-tab-select"
              onChange={(e: any) => { this.setState({selectedTabIdx: parseInt(e.target.value)}) }}
              label={localize('static.content.search-month')}
              required={false}
              value={this.state.selectedTabIdx.toString()}
              items={mobileTabItems}
              tabIndex={0}
            />
          } 
          {this.state.windowWidth > 900 &&
            <div className='tabs'>
              {resort.tabs.map((tab: any, i: number) => (
                <button
                  onClick={() => this.setState({ selectedTabIdx: i })}
                  className={`${this.state.selectedTabIdx === i ? 'selected' : ''}`}
                >
                  {tab.tabName}
                </button>
              ))}
            </div>
          } 

          <div className='tab-content'>
              {ReactHtmlParser(resort.tabs[this.state.selectedTabIdx].tabData)}
          </div>
        </div>
      );
    }

    return (
      <div className={`mv-resort-modal ${this.props.show ? 'show' : ''} ${this.state.showConfirmNavigateAway ? 'showing-confirm-modal' : ''}`}>
        <MvModal
          openModal={show}
          toggleModal={() => {
            toggle();
            this.setState({selectedTabIdx: 0, galleryIdx: 0});
          }}
        >
            <MvLoader show={apiLoading}>
              {content}
            </MvLoader>
        </MvModal>
        <MvConfirmationModal
            header = ""
            message = {localize("static.content.visit-resort-confirm-header")}
            description = {localize("static.content.visit-resort-confirm-body")}
            abortLabel = {localize("static.content.visit-resort-cancel-btn")}
            confirmLabel = {localize("static.content.visit-resort-confirm-btn")}
            openModal={this.state.showConfirmNavigateAway}
            toggleModal={this.toggleConfirmNavigateAwayModal}
            confirm={() => window.open(this.state.resort.resortUrl, this.props.visitResortNewTab ? '_blank' : '_self')}
            abort={this.toggleConfirmNavigateAwayModal}
        />
      </div>
    );
  }
};

MvResortModal.contextType = LocalizationContext;
export {
  MvResortModal,
};
